<script lang="ts">
export default {
  name: "RightAnalysis",
};
</script>
<script setup lang="ts">
import { store } from '@/store'
import * as echarts from 'echarts'
import { fontSize } from "@/common/common"
import { getEventStatistic } from "@/api/analysisApi/index"
import 'echarts-liquidfill'
import { onMounted } from 'vue'
import BaseEcharts from '@/components/BaseEcharts/index.vue'
import { type EChartsCoreOption } from "@/hooks/useHookEchart"

const dateArr = ref([])
const wzArr = ref([])
const gzhArr = ref([])
const eventOptions = computed(() => ({
  grid: {
    left: '35%',
    right: '10%',
    top: '15%',
    bottom: '8%'
  },
  tooltip: {
    trigger: 'item'
  },
  legend: {
    show: true,
    itemWidth: 20,
    itemHeight: 10,
    left: 'center',
    top: "5%",
    color: '#fff',
    icon: 'rect',
    textStyle: {
      color: '#fff',
      fontSize: fontSize(0.7),
    }
  },
  xAxis: {
    type: 'value',
    // "max": max,
    splitLine: {
      show: true,
      lineStyle: {
        color: '#232e32'
      }
    },
    axisLine: {
      show: false
    },
    axisLabel: {
      show: true,
      color: '#fff',
      fontSize: 12,
    },

    axisTick: {
      show: false
    }
  },
  yAxis: [
    {
      type: 'category',
      inverse: true,
      data: dateArr.value,
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        // "margin": 10,
        color: '#fff',
        fontSize: 12,
        padding: [0, 0, 0, 100] // 上右下左与原位置距离
      },
      textStyle: {

      }
    }
  ],
  series: [
    {
      //内
      type: 'bar',
      barWidth: 10,
      barGap: 0.1,
      name: '本周',
      itemStyle: {
        color: new echarts.graphic.LinearGradient(
          0,
          1,
          0,
          0,
          [
            {
              offset: 0,
              color: 'rgba(20, 230, 182, 0)' // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(0, 230, 182, 1)' // 100% 处的颜色
            }
          ],
          false
        )
      },
      data: wzArr.value
    },
    {
      //内2
      type: 'bar',
      barWidth: 10,
      name: '上周',
      itemStyle: {
        color: new echarts.graphic.LinearGradient(
          0,
          1,
          0,
          0,
          [
            {
              offset: 0,
              color: 'rgba(102, 178,255, 0)' // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(102, 178,255, 1)' // 100% 处的颜色
            }
          ],
          false
        )
      },
      data: gzhArr.value
    }
  ]
}))

const taskData1 = ref()
const eventChartTop1Options = computed(() => ({
  title: {
    text: taskData1.value + '%',
    left: 'center',
    top: 'center',
    itemGap: 0,
    textStyle: {
      color: '#54f3ff',
      fontSize: fontSize(1),
      fontWeight: '600',
      fontFamily: "YouSheBiaoTiHei",
    },
  },
  series: [
    /*仪表盘图，做中间刻度线*/
    {
      type: 'gauge',
      name: '',
      radius: '0%',
      startAngle: '0',
      endAngle: '-359.99',
      center: ['50%', '50%'],
      splitNumber: '80',
      pointer: {
        show: false
      },
      title: {
        show: false
      },
      detail: {
        show: false
      },
      axisLine: {
        lineStyle: {
          width: 20,
          opacity: 0
        }
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: true,
        length: 7,
        lineStyle: {
          color: {
            type: 'linear',
            colorStops: [{
              offset: 0, color: 'rgba(39, 183, 206, 0.32)' // 0% 处的颜色
            }, {
              offset: 1, color: 'rgba(191, 255, 159, 0.32)' // 100% 处的颜色
            }],
          },
          width: 2,
          type: 'solid',
        },
      },
      axisLabel: {
        show: false
      }
    },
    /*内心原型图，展示整体数据概览*/
    {
      name: 'pie',
      type: 'pie',
      roundCap: true,
      clockwise: true,
      startAngle: 260,
      labelLine: {
        show: false
      },
      radius: ['85%', '100%'],
      emphasis: {
        scale: false
      },
      center: ['50%', '50%'],
      data: [
        {
          value: taskData1.value,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [{
              offset: 0,
              color: '#27b7ce'
            }, {
              offset: 1,
              color: '#bfff9f'
            }]),
            shadowColor: 'rgba(1,1,1,0.5)',
            shadowBlur: 1
          }
        },
        {
          value: 100 - taskData1.value,
          name: '',
          itemStyle: {
            color: '#54789b', // 未完成的圆环的颜色
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
          },
          emphasis: {
            color: '#54789b' // 未完成的圆环的颜色
          }
        }]
    }
  ]
}))

const taskData2 = ref()
const eventChartTop2Options = computed(() => ({
  title: {
    text: taskData2.value + '%',
    left: 'center',
    top: 'center',
    itemGap: 0,
    textStyle: {
      color: '#54f3ff',
      fontSize: fontSize(1),
      fontWeight: '600',
      fontFamily: "YouSheBiaoTiHei",
    },
  },
  series: [
    /*仪表盘图，做中间刻度线*/
    {
      type: 'gauge',
      name: '',
      radius: '0%',
      startAngle: '0',
      endAngle: '-359.99',
      center: ['50%', '50%'],
      splitNumber: '80',
      pointer: {
        show: false
      },
      title: {
        show: false
      },
      detail: {
        show: false
      },
      axisLine: {
        lineStyle: {
          width: 20,
          opacity: 0
        }
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: true,
        length: 7,
        lineStyle: {
          color: {
            type: 'linear',
            colorStops: [{
              offset: 0, color: 'rgba(39, 183, 206, 0.32)' // 0% 处的颜色
            }, {
              offset: 1, color: 'rgba(191, 255, 159, 0.32)' // 100% 处的颜色
            }],
          },
          width: 2,
          type: 'solid',
        },
      },
      axisLabel: {
        show: false
      }
    },
    /*内心原型图，展示整体数据概览*/
    {
      name: 'pie',
      type: 'pie',
      roundCap: true,
      clockwise: true,
      startAngle: 260,
      labelLine: {
        show: false
      },
      radius: ['85%', '100%'],
      emphasis: {
        scale: false
      },
      center: ['50%', '50%'],
      data: [
        {
          value: taskData2.value,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [{
              offset: 0,
              color: '#27b7ce'
            }, {
              offset: 1,
              color: '#bfff9f'
            }]),
            shadowColor: 'rgba(1,1,1,0.5)',
            shadowBlur: 1
          }
        },
        {
          value: 100 - taskData2.value,
          name: '',
          itemStyle: {
            color: '#54789b', // 未完成的圆环的颜色
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
          },
          emphasis: {
            color: '#54789b' // 未完成的圆环的颜色
          }
        }]
    }
  ]
}))

const taskData3 = ref()
const eventChartTop3Options = computed(() => ({
  title: {
    text: taskData3.value + '%',
    left: 'center',
    top: 'center',
    itemGap: 0,
    textStyle: {
      color: '#54f3ff',
      fontSize: fontSize(1),
      fontWeight: '600',
      fontFamily: "YouSheBiaoTiHei",
    },
  },
  series: [
    /*仪表盘图，做中间刻度线*/
    {
      type: 'gauge',
      name: '',
      radius: '0%',
      startAngle: '0',
      endAngle: '-359.99',
      center: ['50%', '50%'],
      splitNumber: '80',
      pointer: {
        show: false
      },
      title: {
        show: false
      },
      detail: {
        show: false
      },
      axisLine: {
        lineStyle: {
          width: 20,
          opacity: 0
        }
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: true,
        length: 7,
        lineStyle: {
          color: {
            type: 'linear',
            colorStops: [{
              offset: 0, color: 'rgba(39, 183, 206, 0.32)' // 0% 处的颜色
            }, {
              offset: 1, color: 'rgba(191, 255, 159, 0.32)' // 100% 处的颜色
            }],
          },
          width: 2,
          type: 'solid',
        },
      },
      axisLabel: {
        show: false
      }
    },
    /*内心原型图，展示整体数据概览*/
    {
      name: 'pie',
      type: 'pie',
      roundCap: true,
      clockwise: true,
      startAngle: 260,
      labelLine: {
        show: false
      },
      radius: ['85%', '100%'],
      emphasis: {
        scale: false
      },
      center: ['50%', '50%'],
      data: [
        {
          value: taskData3.value,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [{
              offset: 0,
              color: '#27b7ce'
            }, {
              offset: 1,
              color: '#bfff9f'
            }]),
            shadowColor: 'rgba(1,1,1,0.5)',
            shadowBlur: 1
          }
        },
        {
          value: 100 - taskData3.value,
          name: '',
          itemStyle: {
            color: '#54789b', // 未完成的圆环的颜色
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
          },
          emphasis: {
            color: '#54789b' // 未完成的圆环的颜色
          }
        }]
    }
  ]
}))

const lastMounthList: any = ref([])

const lastMounthChart = () => {
  var chartDom = document.getElementById("lastChartContainer");
  var myChart = echarts.init(chartDom);
  const initOption = {
    tooltip: {
      trigger: 'item',
      formatter: (params: any) => {
        if (params.name) {
          return params.name + ': ' + params.data.eventNum
        }
      },
    },
    series: [
      {
        // value: 50, //  内容 配合formatter
        type: 'liquidFill',
        radius: '70%', // 控制中间圆球的尺寸（此处可以理解为距离外圈圆的距离控制）
        center: ['50%', '50%'],
        data: lastMounthList.value,

        amplitude: '8%', //波浪的振幅
        backgroundStyle: {
          color: {
            type: 'linear',
            x: 1,
            y: 0,
            x2: 0.5,
            y2: 1,
            colorStops: [{
              offset: 1,
              color: 'rgba(4,33,77, 0)'
            }, {
              offset: 0.5,
              color: 'rgba(4,33,77, .5)'
            }, {
              offset: 0,
              color: 'rgba(4,33,77, 1)'
            }],
            globalCoord: false
          },
        },
        // 修改波浪颜色
        color: ['#824DE1', '#18C5FE', '#420BFF'],
        // color: [
        //   {
        //     type: 'linear',
        //     x: 0,
        //     y: 0,
        //     x2: 0,
        //     y2: 1,
        //     colorStops: [
        //       {
        //         offset: 1,
        //         color: '#6CDEFC',
        //       },
        //       {
        //         offset: 0,
        //         color: '#429BF7',
        //       },
        //     ],
        //     globalCoord: false,
        //   },
        // ],
        label: {
          show: false,
        },
        outline: {
          show: false,
        },
      },
      {
        type: 'pie',
        z: 1,
        center: ['50%', '50%'],
        radius: ['72%', '73.5%'], // 控制外圈圆的粗细
        emphasis: {
          scale: false
        },
        data: [
          {
            name: '',
            value: 100,
            labelLine: {
              show: false,
            },
            itemStyle: {
              color: '#00AFFF',
            },
            emphasis: {
              labelLine: {
                show: false,
              },
              itemStyle: {
                color: '#00AFFF',
              },
            },
          },
        ],
      },
      {
        //外发光
        type: 'pie',
        z: 1,
        zlevel: -1,
        radius: ['70%', '90.5%'],
        center: ['50%', '50%'],
        emphasis: {
          scale: false
        },
        clockwise: false,
        itemStyle: {
          borderWidth: 20,
          color: 'rgba(224,242,255,0.3)',
        },
        label: {
          show: false,
        },
        data: [100],
      },
      {
        //底层外发光
        type: 'pie',
        z: 1,
        zlevel: -2,
        radius: ['70%', '100%'],
        center: ['50%', '50%'],
        emphasis: {
          scale: false
        },
        clockwise: false,
        itemStyle: {
          borderWidth: 20,
          color: 'rgba(224,242,255,.2)',
        },
        label: {
          show: false,
        },
        data: [100],
      },
      {
        type: 'pie',
        zlevel: 0,
        silent: true,
        radius: ['78%', '80%'],
        z: 1,
        label: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        data: [100],
      },
    ],
  }
  myChart.setOption(initOption);
  window.addEventListener("resize", function () {
    myChart.resize();
  });
}


const thisMounthList: any = ref([])

const thisMounthChar = () => {
  var chartDom = document.getElementById("thisChartContainer");
  var myChart = echarts.init(chartDom);
  const initOption = {
    tooltip: {
      trigger: 'item',
      formatter: (params: any) => {
        if (params.name) {
          return params.name + ': ' + params.data.eventNum
        }
      },
    },
    series: [
      {
        // value: 50, //  内容 配合formatter
        type: 'liquidFill',
        radius: '70%', // 控制中间圆球的尺寸（此处可以理解为距离外圈圆的距离控制）
        center: ['50%', '50%'],
        data: thisMounthList.value,

        amplitude: '8%', //波浪的振幅
        backgroundStyle: {
          color: {
            type: 'linear',
            x: 1,
            y: 0,
            x2: 0.5,
            y2: 1,
            colorStops: [{
              offset: 1,
              color: 'rgba(4,33,77, 0)'
            }, {
              offset: 0.5,
              color: 'rgba(4,33,77, .5)'
            }, {
              offset: 0,
              color: 'rgba(4,33,77, 1)'
            }],
            globalCoord: false
          },
        },
        // 修改波浪颜色
        color: ['#824DE1', '#18C5FE', '#420BFF'],
        // color: [
        //   {
        //     type: 'linear',
        //     x: 0,
        //     y: 0,
        //     x2: 0,
        //     y2: 1,
        //     colorStops: [
        //       {
        //         offset: 1,
        //         color: '#6CDEFC',
        //       },
        //       {
        //         offset: 0,
        //         color: '#429BF7',
        //       },
        //     ],
        //     globalCoord: false,
        //   },
        // ],
        label: {
          show: false,
        },
        outline: {
          show: false,
        },
      },
      {
        type: 'pie',
        z: 1,
        center: ['50%', '50%'],
        radius: ['72%', '73.5%'], // 控制外圈圆的粗细
        emphasis: {
          scale: false
        },
        data: [
          {
            name: '',
            value: 500,
            labelLine: {
              show: false,
            },
            itemStyle: {
              color: '#00AFFF',
            },
            emphasis: {
              labelLine: {
                show: false,
              },
              itemStyle: {
                color: '#00AFFF',
              },
            },
          },
        ],
      },
      {
        //外发光
        type: 'pie',
        z: 1,
        zlevel: -1,
        radius: ['70%', '90.5%'],
        center: ['50%', '50%'],
        emphasis: {
          scale: false
        },
        clockwise: false,
        itemStyle: {
          borderWidth: 20,
          color: 'rgba(224,242,255,0.3)',
        },
        label: {
          show: false,
        },
        data: [100],
      },
      {
        //底层外发光
        type: 'pie',
        z: 1,
        zlevel: -2,
        radius: ['70%', '100%'],
        center: ['50%', '50%'],
        emphasis: {
          scale: false
        },
        clockwise: false,
        itemStyle: {
          borderWidth: 20,
          color: 'rgba(224,242,255,.2)',
        },
        label: {
          show: false,
        },
        data: [100],
      },
      {
        type: 'pie',
        zlevel: 0,
        silent: true,
        radius: ['78%', '80%'],
        z: 1,
        label: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        data: [100],
      },
    ],
  }
  myChart.setOption(initOption);
  window.addEventListener("resize", function () {
    myChart.resize();
  });
}

const organizationData: any = computed(() => store.informationListStore.informationStore().organizationData)
const eventStatisticList: any = ref([])

const chartsStatistic = () => {
  const params: any = {}
  params.statisticType = 1
  params.provinceCode = import.meta.env.VITE_APP_AREACODE,
    params.cityCode = organizationData.value.cityCode,
    params.areaCode = organizationData.value.areaCode,
    params.orgId = organizationData.value.provinceCode,
    getEventStatistic(params).then((res) => {
      console.log(res.list)
      eventStatisticList.value = res.list
      if (res.list.length <= 1) {
        taskData1.value = parseInt(parseFloat(res.list[0].percent) * 100)
      } else if (res.list.length <= 2) {
        taskData1.value = parseInt(parseFloat(res.list[0].percent) * 100)
        taskData2.value = parseInt(parseFloat(res.list[1].percent) * 100)
      } else if (res.list.length <= 3) {
        taskData1.value = parseInt(parseFloat(res.list[0].percent) * 100)
        taskData2.value = parseInt(parseFloat(res.list[1].percent) * 100)
        taskData3.value = parseInt(parseFloat(res.list[2].percent) * 100)
      } else {
        taskData1.value = parseInt(parseFloat(res.list[0].percent) * 100)
        taskData2.value = parseInt(parseFloat(res.list[1].percent) * 100)
        taskData3.value = parseInt(parseFloat(res.list[2].percent) * 100)
      }
    })
}

const barStatistic = () => {
  const lastWeekParams: any = {}
  lastWeekParams.statisticType = 2
  lastWeekParams.provinceCode = import.meta.env.VITE_APP_AREACODE,
    lastWeekParams.cityCode = organizationData.value.cityCode,
    lastWeekParams.areaCode = organizationData.value.areaCode,
    lastWeekParams.orgId = organizationData.value.provinceCode,
    getEventStatistic(lastWeekParams).then((res) => {
      if(!dateArr.value.length){
        dateArr.value = res.list.map((result: any) => {
          return result.eventType
        })
      }
      wzArr.value = res.list.map((result: any) => {
        return result.eventNum
      })
    })

  const thisWeekParams: any = {}
  thisWeekParams.statisticType = 3
  thisWeekParams.provinceCode = import.meta.env.VITE_APP_AREACODE,
    thisWeekParams.cityCode = organizationData.value.cityCode,
    thisWeekParams.areaCode = organizationData.value.areaCode,
    thisWeekParams.orgId = organizationData.value.provinceCode,
    getEventStatistic(thisWeekParams).then((res) => {
      if(!dateArr.value.length){
        dateArr.value = res.list.map((result: any) => {
          return result.eventType
        })
      }
      gzhArr.value = res.list.map((result: any) => {
        return result.eventNum
      })
    })
}

const baseStatistic = () => {
  const lastMounthParams: any = {}
  lastMounthParams.statisticType = 5
  lastMounthParams.provinceCode = import.meta.env.VITE_APP_AREACODE,
    lastMounthParams.cityCode = organizationData.value.cityCode,
    lastMounthParams.areaCode = organizationData.value.areaCode,
    lastMounthParams.orgId = organizationData.value.provinceCode,
    getEventStatistic(lastMounthParams).then((res) => {
      console.log(res.list)
      if (res.list.length) {
        res.list.forEach((result: any) => {
          lastMounthList.value.push({
            name: result.eventType,
            value: result.percent,
            eventNum: result.eventNum
          })
        })
      }
      lastMounthChart()
      console.log(lastMounthList.value)
    })

  const thisMounthParams: any = {}
  thisMounthParams.statisticType = 4
  thisMounthParams.provinceCode = import.meta.env.VITE_APP_AREACODE,
    thisMounthParams.cityCode = organizationData.value.cityCode,
    thisMounthParams.areaCode = organizationData.value.areaCode,
    thisMounthParams.orgId = organizationData.value.provinceCode,
    getEventStatistic(thisMounthParams).then((res) => {
      console.log(res.list)
      if (res.list.length) {
        res.list.forEach((result: any) => {
          thisMounthList.value.push({
            name: result.eventType,
            value: result.percent,
            eventNum: result.eventNum
          })
        })
      }
      thisMounthChar()
      console.log(thisMounthList.value)
    })
}

watch(() => store.informationListStore.informationStore().organizationData, (newVal, oldVal) => {
  chartsStatistic()
  barStatistic()
  baseStatistic()
}, {
  immediate: true,
  deep: true
})

onMounted(() => {

})
</script>

<template>
  <div class="right-analysis">

    <div class="event-statistics-box">
      <div class="small-title mt30">事件统计</div>
      <div class="day-word">七日内</div>
      <div class="event-list-box">
        <div class="chartBox" v-if="eventStatisticList.length > 0">
          <div style="color: #FF4848;">Top1.</div>
          <div class="eventChart">
            <base-echarts :options="eventChartTop1Options" />
          </div>
          <div class="eventtype">{{ eventStatisticList[0].eventType }}</div>
        </div>
        <div class="chartBox" v-if="eventStatisticList.length > 1">
          <div style="color: #FFCC00;">Top2.</div>
          <div class="eventChart">
            <base-echarts :options="eventChartTop2Options" />
          </div>
          <div class="eventtype">{{ eventStatisticList[1].eventType }}</div>
        </div>
        <div class="chartBox" v-if="eventStatisticList.length > 2">
          <div style="color: #FF7700;">Top3.</div>
          <div class="eventChart">
            <base-echarts :options="eventChartTop3Options" />
          </div>
          <div class="eventtype">{{ eventStatisticList[2].eventType }}</div>
        </div>
      </div>
    </div>

    <div class="task-statistics-box">
      <div class="small-title">事件分析</div>
      <div class="taskChart">
        <base-echarts :options="eventOptions" />
      </div>
      <div class="importent-event">
        <div class="chartBox">
          <p>上月</p>
          <div class="lastMounthChart">
            <div id="lastChartContainer" style="width: 100%; height: 100%;"></div>
          </div>
          <p>重点事件</p>
          <p style="color: #fff837;" v-if="lastMounthList.length">{{ lastMounthList[0].name }}</p>
          <p style="color: #FF4848;" v-else>暂无</p>
        </div>
        <div class="chartBox">
          <p>本月</p>
          <div class="currentMonthChart">
            <div id="thisChartContainer" style="width: 100%; height: 100%;"></div>
          </div>
          <p>重点事件</p>
          <p style="color: #fff837;" v-if="thisMounthList.length">{{ thisMounthList[0].name }}</p>
          <p style="color: #FF4848;" v-else>暂无</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.right-analysis {
  position: absolute;
  top: 7.5rem;
  right: 0;
  width: 21.1vw;
  height: 88vh;
  background: url("@/assets/images/right-monitor-bj.png") no-repeat center;
  background-size: 100% 100%;

  .event-statistics-box {
    height: 24vh;
    margin-top: 1.25rem;

    .day-word {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 1rem;
      color: #00FFD4;
      margin-left: 3.75rem;
      margin-top: 1.25rem;
    }

    .event-list-box {
      width: 80%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;

      .chartBox {

        margin-top: 1.25rem;

        div:nth-child(1) {
          font-weight: 600;
          font-size: 1rem;
          text-align: center;
          font-style: italic;
        }

        .eventChart {
          width: 5vw;
          height: 8.1vh;
          margin: 0.625rem auto;
        }

        div:nth-child(3) {
          font-weight: 400;
          font-size: 14px;
          color: #F6F9FE;
          width: 100px;
          text-align: center;
        }
      }
    }
  }

  .task-statistics-box {
    height: 60vh;

    .taskChart {
      width: 100%;
      height: 30vh;
    }

    .importent-event {
      display: flex;

      .chartBox {
        width: 50%;
        margin: 0 auto;

        p {
          text-align: center;
          color: #fff;
          margin-top: 10px;
        }

        .lastMounthChart {
          width: 80%;
          height: 16vh;
          margin: 0 auto;
          margin-top: 0.625rem;
        }

        .currentMonthChart {
          width: 80%;
          height: 16vh;
          margin: 0 auto;
          margin-top: 0.625rem;
        }
      }
    }
  }

}
</style>
